import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBreadcrumbDivider = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8} height={14} fill="none" {...props}>
    <path stroke="#343333" d="m1 13 6-6-6-6" />
  </svg>
);
export default SvgBreadcrumbDivider;
